import { MS_PER_HOUR } from '../model/constants';
import { BlockStatus } from '../model/enums';
import type { Settings } from '../model/settings';
import type { TimeBlockRecord } from '../model/types';
import { epochOfWallMin } from '../time/personal-day';

/**
 * A draft expires `draftExpiryHours` after the start of its personal day (local wall clock).
 * Expiry is computed from time, never stored.
 */
export function isDraftExpired(
  personalDate: string,
  settings: Pick<Settings, 'dayStartMin' | 'draftExpiryHours'>,
  nowMs: number,
): boolean {
  const dayStart = epochOfWallMin(personalDate, settings.dayStartMin);
  return nowMs > dayStart + settings.draftExpiryHours * MS_PER_HOUR;
}

/** False for a deleted block or a draft that has expired; such blocks are not shown. */
export function isBlockVisible(
  block: TimeBlockRecord,
  settings: Pick<Settings, 'dayStartMin' | 'draftExpiryHours'>,
  nowMs: number,
): boolean {
  const data = block.data;
  if (block.deleted || data === null) return false;
  return !(data.status === BlockStatus.Draft && isDraftExpired(data.personalDate, settings, nowMs));
}
